import React, { Component } from 'react';

import HttpRunner from '../query';
import examples from '../../../utils/examples';
import urlHandler from '../../../utils/urlHandler';
import perms from '../../../utils/permissions';

class DocV1AdminSysInfo extends Component {
    constructor(props){
        super(props);

        this.state = {
            dynamicSample: false
        }
    }

    componentDidMount() {
        this.setState({
            dynamicSample: perms.checkEndpoint(urlHandler.API_ENDPOINT_V1_ADMIN_SYSINFO)
        }) 
    }

    render() {
        return (
            <div className="bucket" id="top">
                <span id="sysinfo_endpoint">
                    <span className='heading-1'>Admin Sysinfo</span>
                </span>
                <code className="api-definition">
                    <span className="get-badge">GET</span>&nbsp;{urlHandler.API_ENDPOINT_V1_ADMIN_SYSINFO}
                </code>
                <div className="description">
                    Returns information about the deployment and runtime aspects of Finch For Text®.
                </div>

                <div className="deprecated">
                    <span className="fa fa-exclamation-triangle">&nbsp;</span>
                    This request is only available to on-prem customers of Finch For Text.
                </div>
                
                <h4 className="heading-2">Response</h4>
                <table className="table-wrapper">
                    <thead className="table-header">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Type </th>
                        <th>Notes </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">agent_deployment</td>
                        <td className="meaning">Information about the TRIT agent service.</td>
                        <td className="type">JSON Object<br/>
                            <br/>
                            See <a href="#deployment_object">Deployment Object</a>    
                        </td>
                        <td className="type">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute">deployment</td>
                        <td className="meaning">Information about gateway service.</td>
                        <td className="type">JSON Object<br/>
                            <br/>
                            See <a href="#deployment_object">Deployment Object</a>    
                        </td>
                        <td className="type">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute">language_detection_deployment</td>
                        <td className="meaning">Information about language detection service.</td>
                        <td className="type">JSON Object<br/>
                            <br/>
                            See <a href="#deployment_object">Deployment Object</a>    
                        </td>
                        <td className="type">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute">sentiment_deployment</td>
                        <td className="meaning">Information about sentiment service.</td>
                        <td className="type">JSON Object<br/>
                            <br/>
                            See <a href="#deployment_object">Deployment Object</a>    
                        </td>
                        <td className="type">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute">summarize_deployment</td>
                        <td className="meaning">Information about summarization service.</td>
                        <td className="type">JSON Object<br/>
                            <br/>
                            See <a href="#deployment_object">Deployment Object</a>    
                        </td>
                        <td className="type">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute">text_correction_deployment</td>
                        <td className="meaning">Information about text correction service.</td>
                        <td className="type">JSON Object<br/>
                            <br/>
                            See <a href="#deployment_object">Deployment Object</a>    
                        </td>
                        <td className="type">Optional</td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-3" id="deployment_object">Deployment Object</h4>
                <div className="description">
                    The response object that contains deployment information for a particular service.
                </div>

                <table className="table-wrapper">
                    <thead className="table-header">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Type </th>
                        <th>Notes </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">version</td>
                        <td className="meaning">The version of the REST service.</td>
                        <td className="type">String</td>
                        <td className="type"></td>
                    </tr>
                    <tr>
                        <td className="attribute">build_date</td>
                        <td className="meaning">The software build date of the REST service.</td>
                        <td className="type">Date String</td>
                        <td className="type">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute">max_request_size_kb</td>
                        <td className="meaning">
                            The maximum size (in kilobytes) of input text that FFT will process. 
                            Requests larger than this will return a HTTP status code 413 (Request Entity Too Large).
                        </td>
                        <td className="type">Positive Integer</td>
                        <td className="type">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute">*_url</td>
                        <td className="meaning">Internal use only. URL’s for internal FFT services.</td>
                        <td className="type">String</td>
                        <td className="type">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute">endpoints</td>
                        <td className="meaning">List of endpoints the service handles.</td>
                        <td className="type">JSON Array</td>
                        <td className="type">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute">environment</td>
                        <td className="meaning">Internal use only. List of environment variables set for the service.</td>
                        <td className="type">JSON Object</td>
                        <td className="type">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute">name</td>
                        <td className="meaning">Name of the service.</td>
                        <td className="type">String</td>
                        <td className="type">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute">tornado</td>
                        <td className="meaning">If the service uses tornado, the version used.</td>
                        <td className="type">String</td>
                        <td className="type">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute">backlog</td>
                        <td className="meaning">Represents the maximum number of requests that can be queued by the server to wait for processing.</td>
                        <td className="type">Integer</td>
                        <td className="type">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute">models</td>
                        <td className="meaning">The data models that are loaded.</td>
                        <td className="type">JSON Array</td>
                        <td className="type">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute">threads</td>
                        <td className="meaning">The number of threads the service is configured to use.</td>
                        <td className="type">Integer</td>
                        <td className="type">Optional</td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-2">Example</h4>
                <HttpRunner query="admin/sysinfo" stated="admin/sysinfo"
                    response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_V1_ADMIN_SYSINFO) : null}
                />
            </div>
        );
    }
}

export default DocV1AdminSysInfo;